/**
 * 云服务类别 产品实例列表 导出数据Dialog
 *
 * @format
 */

import React, { useState, useEffect, useContext } from 'react'
import { _$, Dialog, Tabs, Tab, Tag } from 'kpc-react'
import styled from 'styled-components'
import { CountContext } from 'src/pages/MonitorCloud/MonitorCloudList'

interface DiabolBatchExportProps {
  visible: boolean
  handleChange: (c: any, show: boolean) => void
  checkedData: any[]
  className?: string
}

const DiabolBatchExport: React.FC<DiabolBatchExportProps> = ({
  visible,
  handleChange,
  checkedData,
  className
}) => {
  const { childTypes } = useContext(CountContext)
  const [tabsValue, setTabsValue] = useState('exportItem')
  const [checkedList, setCheckedList] = useState<any[]>([])
  useEffect(() => {
    if (visible) {
      if (childTypes) {
        childTypes.forEach(child => {
          checkedData.forEach(data => {
            getHostExtProperty(child.childType, data.instanceId)
          })
        })
      } else {
        setCheckedList(checkedData)
      }
    } else {
      setCheckedList([])
    }
  }, [visible])

  // 获取child扩展集
  const getHostExtProperty = async (childType, instanceId) => {
    // const { data } = await request('/monitorapi/host/getHostExtProperty', {
    //   method: 'POST',
    //   data: {
    //     childType,
    //     parentInstanceId: instanceId,
    //     productType
    //   }
    // })
    // data && setCheckedList(checkedList => [...checkedList, ...data])
  }

  return (
    <Dialog value={visible} on$change-value={handleChange} title={_$('批量导出')}>
      <Tabs value={tabsValue} on$change-value={(c, tab) => setTabsValue(tab)}>
        <Tab value="instanceList">
          {_$('已选实例')}（{checkedList?.length || 0}）
        </Tab>
        <Tab value="exportItem">{_$('输出字段')}</Tab>
      </Tabs>
      <div className={className}>
        {tabsValue === 'instanceList' && (
          <ul className="instance-list">
            {!!checkedList.length &&
              checkedList.map(({ hostId, hostName, instanceType, instanceid, instancename }) => {
                const isHostGroup = instanceType === 2
                return (
                  <li key={hostId || instanceid}>
                    {isHostGroup && (
                      <Tag size="mini" type="primary">
                        {_$('实例组')}
                      </Tag>
                    )}
                    <p className={isHostGroup ? 'primary-color' : ''}>
                      {hostName || instancename} （{hostId || instanceid}）
                    </p>
                  </li>
                )
              })}
          </ul>
        )}
      </div>
    </Dialog>
  )
}

export default styled(DiabolBatchExport)`
  padding: 20px 20px 0;
  .instance-list {
    max-height: 300px;
    overflow-y: auto;
    li {
      display: flex;
      align-items: center;
      .k-tag {
        margin-right: 5px;
      }
      p {
        line-height: 28px;
        margin-bottom: 0;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding-right: 10px;
      }
    }
  }
`
